module.exports = __webpack_public_path__ + "static/media/accesorios-barandales-slide-4.7a571b34.jpg";